// extracted by mini-css-extract-plugin
module.exports = {"sign_form":"sign_sign_form__1lHAj","changeUi":"sign_changeUi__21bHW","ant-form-item-label":"sign_ant-form-item-label__2M5_H"};